export default function initLinkable() {
  document.addEventListener(`click`, (e) => {
    if (
      e.defaultPrevented ||
      e.target.closest(`[data-linkable-exclude="true"]`)
    )
      return

    const target = e.target.closest(
      `[data-linkable]:not(a, button, label, input, select, textarea)`
    )

    if (!target) return

    const url = (target.dataset.linkable || ``).trim()
    if (!url) return

    if (e.ctrlKey || e.metaKey) {
      window.open(url, `_blank`, `noopener`)
    } else if (window.liveSocket) {
      window.liveSocket.js().navigate(url)
    } else {
      window.location.href = url
    }
  })
}
